import { createFileRoute } from "@tanstack/react-router";

import { EvidenceHubPage } from "@/components/pages/EvidenceHubPage";

export const Route = createFileRoute("/_authenticated/evidence-hub/")({
  component: EvidenceHubPage,
});
